'use client';

import { ChevronLeftIcon } from '@heroicons/react/20/solid';
import { useCurrentFlowStep } from '~/lib/flow-steps';
import { useFormContext } from '~/lib/providers/form-context';

export function DesktopFlowHeader() {
  const { goToPreviousStep } = useFormContext();
  const match = useCurrentFlowStep();

  if (!match || match.step.key === 'confirmation') return null;

  const { index, total } = match;
  const progress = ((index + 1) / total) * 100;

  return (
    <header className="flex items-center gap-x-6 px-8 py-5 xl:px-12">
      <button
        type="button"
        onClick={goToPreviousStep}
        aria-label="Back"
        className="inline-flex size-11 shrink-0 items-center justify-center rounded-full bg-surface-1 shadow-sm ring-1 ring-border transition-all hover:ring-border-strong"
      >
        <ChevronLeftIcon className="size-5 text-fg-muted" aria-hidden="true" />
      </button>
      <div
        className="relative h-1 flex-1 overflow-hidden rounded-full bg-border"
        role="progressbar"
        aria-label={`Application progress, step ${index + 1} of ${total}`}
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={index + 1}
      >
        <div
          className="absolute inset-y-0 left-0 w-(--progress) rounded-full bg-accent transition-[width] duration-300"
          style={{ '--progress': `${progress}%` } as React.CSSProperties}
        />
      </div>
      <p className="shrink-0 font-mono text-xs font-semibold tracking-[0.12em] text-fg-muted tabular-nums">
        {String(index + 1).padStart(2, '0')} / {String(total).padStart(2, '0')}
      </p>
    </header>
  );
}
